import { ButtonBase, styled } from '@mui/material';

export const FleetTypeRadioGroupButton = styled(ButtonBase)(({ theme }) => ({
    '&& .MuiTouchRipple-child': {
        backgroundColor: theme.palette.primary.main,
    },
}));
